export enum RequestType {
  MINT = 'MINT',
  BURN = 'BURN'
  // SEND_THIRD_PARTY = 'SEND_THIRD_PARTY'
}
